import { debounce, noop } from "lodash-es";
import { DirectiveOptions } from "vue";

import { InteractionsService } from "@/services/InteractionsService";
import store from "@/store/store";

export const vInteract: DirectiveOptions = {
  bind(el, binding) {
    const { type, context } = binding.value;
    el.addEventListener("click", debounce(() => {
      const user = store.state.users.authentication.user;
      if (!!user) {
        InteractionsService.addInteraction({ type, context: JSON.stringify(context) })
          .subscribe(noop, (error) => {
            // tslint:disable-next-line:no-console
            console.error("Error tracking interaction", error);
          });
      }
    }, 2000));
  }
};
